import { useMemo, useState } from "react";
import { number, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { Tables, hashCode } from "@repo/utils";
import { SectionName, SectionTitle, useEstimateEditorSettings } from "@tools";
import { TableHeader } from "../TableHeader/TableHeader";
import { SectionSummaryRow } from "../SectionSummaryRow/SectionSummaryRow";
import { BreakdownRowGroupList } from "../BreakdownRowGroupList";
import { SectionContainer } from "./SectionContainer";


export const LibrarySection = ({
  section,
  index,
}) => {
  const {t} = useTranslation();
  const { allowEdition } = useEstimateEditorSettings();
  
  const [headerRef, setHeaderRef] = useState(null);
  
  /** @note: If we ever decide to change section ids during runtime, we need to make this component an observer */
  const { id, name } = section;
  
  const hashedPath = useMemo(() => (
    [Tables.BREAKDOWN, id].map((id) => hashCode(id))
  ), [id]);
  
  const tableIdentifier = useMemo(() => `tableHeader${index}`, [index]);
  
  return (
    <SectionContainer
      index={index}
      section={section}
      headerRef={headerRef}
    >
      <SectionTitle id={"sectionTitle" + index}>
        <SectionName
          id={id}
          defaultName={t(`proposal_parts.section_titles.${name}`)}
          colored
        />
      </SectionTitle>
      <TableHeader
        ref={setHeaderRef}
        section={ section }
        tableIdentifier={ tableIdentifier }
      />
      <BreakdownRowGroupList
        initialDepth={ section.startingLevel - 1 }
        element={ section }
        sectionIndex={ index }
        isLastGroupRow
        disabled={!allowEdition}
        hashedPath={hashedPath}
      />
      {
        allowEdition &&
        <SectionSummaryRow
          section={ section }
          isFirst={ index === 0 }
        />
      }
    </SectionContainer>
  );
};

LibrarySection.propTypes = {
  section: object.isRequired,
  index: number.isRequired,
};
